
import { computed, defineComponent, PropType, ref, watch } from 'vue'

export default defineComponent({
  name: 'AlTextInput',
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'update:modelValue',
  },
  $_veeValidate: {
    value () {
      return (this as any).inputValue
    },
    name () {
      return (this as any).name
    },
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String as PropType<HTMLInputElement['type']>,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      default: 'md',
    },
  },
  setup (props, { emit }) {
    const inputValue = ref(props.value)

    const $_veeValidate = computed(() => {
      return {
        value: inputValue.value,
      }
    })

    watch(() => props.value, (value) => {
      inputValue.value = value
    })

    watch(() => inputValue.value, (value) => {
      emit('update:modelValue', value)
    })

    const listeners = {
      ...Object.fromEntries(
        Object.entries(props).filter(([key]) => key.startsWith('on')),
      ),
    }

    return {
      $_veeValidate,
      inputValue,
      listeners,
    }
  },
})
